import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { Modal } from '../../../common/modal';
import { ENTRY_TYPES } from '../../../models/GlossaryText';
import { SecondaryButton } from '../../secondary-button';
import { GlossaryStore } from '../stores/GlossaryStore';
import styles from './GlossaryModal.css';

const IPropTypes = {
  entryType: PropTypes.oneOf([
    ENTRY_TYPES.IMAGE,
    ENTRY_TYPES.DEFINITION,
  ]).isRequired,
  onClose: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
};

const defaultProps = {
  onClose: () => {},
};

class GlossaryModal extends React.Component {
  static renderDefinition() {
    if (GlossaryStore.loading) {
      return (
        <p>
          Cargando
        </p>
      );
    } else if (GlossaryStore.error) {
      return (
        <React.Fragment>
          <p>
            No hemos podido obtener la definición
          </p>
          <SecondaryButton>
            Reintentar
          </SecondaryButton>
        </React.Fragment>
      );
    } else if (GlossaryStore.definition) {
      return (
        GlossaryStore.definition.split('\r\n').map(line => (
          <p key={line}>
            {line}
          </p>
        ))
      );
    }
    return null;
  }

  constructor(props) {
    super(props);
    this._onClose = this._onClose.bind(this);
  }

  componentDidMount() {
    if (this.props.entryType === ENTRY_TYPES.DEFINITION) {
      GlossaryStore.getDefinition(this.props.value);
    }
  }

  _renderImage() {
    return (
      <img
        alt=""
        className={styles.image}
        src={this.props.value}
      />
    );
  }

  _onClose(event) {
    event.preventDefault();
    this.props.onClose();
  }

  render() {
    return (
      <Modal>
        <div className={styles.container}>
          <div className={styles.entryContainer}>
            {
              this.props.entryType === ENTRY_TYPES.IMAGE &&
              this._renderImage()
            }
            {
              this.props.entryType === ENTRY_TYPES.DEFINITION &&
              GlossaryModal.renderDefinition()
            }
          </div>
          <SecondaryButton
            className={styles.button}
            onClick={this._onClose}
          >
            Cerrar
          </SecondaryButton>
        </div>
      </Modal>
    );
  }
}

GlossaryModal.propTypes = IPropTypes;
GlossaryModal.defaultProps = defaultProps;

const ObservedGlossaryModal = observer(GlossaryModal);

export { ObservedGlossaryModal as GlossaryModal };



// WEBPACK FOOTER //
// ./src/common/glossary-entry/glossary-modal/GlossaryModal.jsx